import store from '@/store';
/*

    LocalStorage에 저장 된 정보가 있다면 Vuex에 저장합니다.
    main.ts에서 store load 후 호출 되어야 합니다.

*/
export default function install() {
  const getLoaclStorage = localStorage.getItem('dpost-v1');

  if (!getLoaclStorage) return;

  const fetchData = JSON.parse(getLoaclStorage as string);

  store.dispatch('auth/updateSessionToken', fetchData.auth.sessionToken);
  store.dispatch('auth/updateClientInfo', fetchData.auth.clientInfo);
  store.dispatch('auth/updateCenterInfo', fetchData.auth.centerInfo);
  store.dispatch('auth/updateMarketingAgreement', fetchData.auth.marketing);

  //로컬스토리지에 오늘 접수공지팝업 표시 데이터 저장
  const getPopupLocalStorage = localStorage.getItem('popupOpenFrom');

  if (getPopupLocalStorage) localStorage.setItem('popupOpenFrom', getPopupLocalStorage);
  else store.dispatch('localStorage/savePopupDataLocalStorage');
}
